export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./branch-games-general-settings.vue?vue&type=template&id=0c0f053b"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/games/branch-games-general-settings.vue?vue&type=template&id=0c0f053b
// module id = PuZr
// module chunks = 0